import React from 'react';
import Widget from '../Widget/Widget.js'

class TextWidget extends React.Component {
  render() {

    var value = "";

    if(this.props.value === undefined || this.props.value === "") {
      value = "No data available";
    } else {
      value = this.props.value;
    }

    return (
      <Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center">
            <h1 className="text-center">{this.props.title}</h1>
            <h2 className="text-center">{value}</h2>
          </div>
        </div>
      </Widget>
    )
  }
}

export default TextWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/TextWidget/TextWidget.js